import React from 'react';
import { InputBase, makeStyles, fade } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { withRouter } from 'react-router-dom';

import { searchUser } from '../../actions/profileActions';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
    transition: 'all 0.3s',
  },
  searchIcon: {
    position: 'absolute',
    top: '50%',
    left: theme.spacing(2),
    transform: 'translateY(-50%)',
    color: '#aaa',
    pointerEvents: 'none',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 6),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    border: '1px solid #ccc',
    '&:focus': {
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 2px ${fade(theme.palette.primary.main, 0.3)}`,
    },
    '&::placeholder': {
      color: '#aaa',
      transition: 'opacity 0.3s',
    },
    '&:focus::placeholder': {
      opacity: 0.5,
    },
  },
}));

const SearchForm = ({ history }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    if (e.key === 'Enter') {
      dispatch(searchUser({ text: e.target.value }, history));
    }
  };

  return (
    <div className={classes.search}>
      <div className={classes.searchIcon}>
        <SearchIcon />
      </div>
      <InputBase
        placeholder="Search user"
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput,
        }}
        onKeyPress={handleSubmit}
      />
    </div>
  );
};

export default withRouter(SearchForm);
